import axios from "axios";
import { scratchData } from "./data"; // Your game's data store
import { gameId } from "../../../components/urlParams";

const BASE_URL = process.env.REACT_APP_USER_API_URL;

export const ApiService = {
    /**
     * Initializes the API service with the backend base URL.
     * This function might not be strictly needed if BASE_URL is always from process.env,
     * but can be kept for consistency or if baseUrl can be dynamic.
     * @param {string} baseUrl The base URL for your game's backend API.
     */
    initializeApi: function(baseUrl) {
        // scratchData.baseUrl = baseUrl; // If baseUrl is always from process.env, this might be redundant
    },

    /**
     * Handles user login and retrieves the JWT token.
     * @param {object} credentials User login credentials (e.g., { username, password })
     * @returns {Promise<boolean>} True if login is successful, false otherwise.
     */
    loginUser: async function(credentials) {
        try {
            const response = await axios.post(`${BASE_URL}auth/login`, credentials);
            scratchData.jwtToken = response.data.accessToken;
            scratchData.userId = response.data.user.id;
            scratchData.balance = response.data.wallet.balance;
            // Set default authorization header for all subsequent requests if you want to use it globally
            axios.defaults.headers.authorization = `accessToken=${scratchData.jwtToken}`;
            return true;
        } catch (error) {
            console.error("Login failed:", error);
            return false;
        }
    },

    /**
     * Makes an API call to get any pending bet for the user.
     * @returns {Promise<object>} The pending bet data, or an empty object if no pending bet.
     */
    getLastPendingBet: async function() {
        const gameId = scratchData.gameId;
        if (!scratchData.jwtToken) {
            console.error("No JWT token available. User must log in.");
            throw new Error("No authorization token.");
        }

        // Ensure the latest token is used for the header for this request
        axios.defaults.headers.authorization = `accessToken=${scratchData.jwtToken}`;

        try {
            const endpoint = `${BASE_URL}scratch-coin/get-pending-bet?gameId=${gameId}&currencyId=1`;
            const response = await axios.get(endpoint);
            const data = response.data;
            return data;
        } catch (error) {
            console.error("Get pending bet API failed:", error);
            throw error;
        }
    },

    /**
     * Makes an API call to buy tickets for the scratch game.
     * @param {object} ticketDetails Details for buying tickets (betAmount, gameId, currencyId).
     * @returns {Promise<object>} The response data from the buy tickets API.
     */
    buyTickets: async function(ticketDetails) {
        if (!scratchData.jwtToken) {
            console.error("No JWT token available. User must log in.");
            throw new Error("No authorization token.");
        }

        axios.defaults.headers.authorization = `accessToken=${scratchData.jwtToken}`;

        const payload = {
            betAmount: ticketDetails.betAmount,
            gameId: scratchData.gameId,
            currencyId: ticketDetails.currencyId,
        };

        try {
            const response = await axios.post(`${BASE_URL}scratch-coin/buy-tickets`, payload);
            return response.data;
        } catch (error) {
            console.error("Buy tickets API failed:", error);
            // You can add more specific error handling here if needed
            throw error;
        }
    },

    /**
     * Makes an API call to initiate the coin play game.
     * @param {object} gameDetails Details for starting the game (gameId, clientSeed, isCheatMode, cheatModeType, currencyId).
     * @returns {Promise<object>} The response data from the coin play game API.
     */
    coinPlayGame: async function(gameDetails) {
        if (!scratchData.jwtToken) {
            console.error("No JWT token available. User must log in.");
            throw new Error("No authorization token.");
        }

        axios.defaults.headers.authorization = `accessToken=${scratchData.jwtToken}`;

        const payload = {
            gameId: scratchData.gameId,
            clientSeed: gameDetails.clientSeed,
            isCheatMode: gameDetails.isCheatMode,
            cheatModeType: gameDetails.cheatModeType,
            currencyId: gameDetails.currencyId,
        };

        try {
            const response = await axios.post(`${BASE_URL}scratch-coin/coin-play-game`, payload);
            return response.data;
        } catch (error) {
            console.error("Coin Play Game API failed:", error);
            // Add specific error handling for this API if needed
            throw error;
        }
    },

    scratchScore: async function(index) {
        if (!scratchData.jwtToken) {
            console.error("No JWT token available. User must log in.");
            throw new Error("No authorization token.");
        }

        axios.defaults.headers.authorization = `accessToken=${scratchData.jwtToken}`;

        const payload = {
            gameId: scratchData.gameId, 
            currencyId: 1,
            userId: scratchData.userId,
            scoreIndex: index,
        };

        try {
            const response = await axios.post(`${BASE_URL}scratch-coin/scratch-score`, payload);
            return response.data;
        } catch (error) {
            console.error("Scratch Score API failed:", error);
            throw error;
        }
    },

    scratchCoinScore: async function(index) {
        if (!scratchData.jwtToken) {
            console.error("No JWT token available. User must log in.");
            throw new Error("No authorization token.");
        }

        axios.defaults.headers.authorization = `accessToken=${scratchData.jwtToken}`;

        const payload = {
            gameId: scratchData.gameId, 
            currencyId: 1,
            userId: scratchData.userId,
            scoreIndex: index,
        };

        try {
            const response = await axios.post(`${BASE_URL}scratch-coin/scratch-coin-score`, payload);
            return response.data;
        } catch (error) {
            console.error("Scratch coin Score API failed:", error);
            throw error;
        }
    },

    
};